export default import.meta.ROLLDOWN_FILE_URL_nfxOILSplT_DQ7QPK1bMGA